'use strict';
/**
 * [init initilizes tabs]
 * @param  {[string]} scope [css selector]
 * @return {[undefined]}    [nothing returned]
 */
export function init(scope) {
    // Initialize raty plugin
    const $RatingScore = $('.Rating__Score');
    const $RatingToRate = $('.Rating__ToRate');
    $RatingScore.raty({ readOnly: true, half: true, path: "/css/img/plugins/raty", hints: ['', '', '', '', '']});
    $RatingToRate.raty({ path: "/css/img/plugins/raty", hints: ['','','','',''] });

    $(".Rating__ToRate > img").click(function () {
        var score = $(this).attr("alt");
        var pageId = $(this).parent().data("page");

        $.ajax({
            type: "POST",
            url: "/umbraco/Surface/RecipePageSurface/PostRating?pageId=" + pageId + "&rating=" + score,
            dataType: "json",
            success: function (data) {
                if (data.Success) {
                    // Reload ratings partial view
                    $.ajax({
                        type: "GET",
                        url: "/umbraco/Surface/RecipePageSurface/GetRatingPartial?pageId=" + pageId,
                        success: function (partial) {
                            $("#rating").html(partial);
                            // Update raty plugin
                            let ratingScore = $(".Rating__Score");
                            ratingScore.raty({ score: data.Rating, readOnly: true, half: true, path: "/css/img/plugins/raty", hints: ['', '', '', '', ''] })
                            $(".Rating__Votes").text(data.NumberOfVotes);
                            $(".Rating__Current").html(data.Rating.replace(".", ",").toFixed(1));
                            $(".Rating__ToRate").parent().remove();
                        }
                    });
                }
                else {
                    console.log("Failed - " + data.Message);
                }

            },
            error: function () {
                alert('En fejl skete ved bedømmelse');
            }
        });
    });

    return false;
}
